"use strict";
module.exports = require("./ajax");



// WEBPACK FOOTER //
// ./src/js/escolha/ajax/index.js